<template>
  <gg-card>
    <v-card-text class="pt-0 text-left">
      <v-col cols="24" md="12" class="pl-0">
        <v-alert type="error" icon="mdi-alert">
          Your service(s) will be scheduled for cancellation. Please back up any important data before proceeding. If you have other services or domains you would like to cancel, you must submit a separate request.
        </v-alert>
      </v-col>
      <h2>Services to be Cancelled:</h2>
      <v-list>
        <v-list-item v-if="cancellation_type === 'full'">
          <v-list-item-content>{{ decodeHtmlCharCodes(this.selected_cr_service.name) }}</v-list-item-content>
        </v-list-item>
        <v-list-item v-for="service in servicesForCancellation" :key="`service-${service.id}`">
          <v-list-item-content>
            {{ decodeHtmlCharCodes(service.name) }} {{ service.domain ? `- ${service.domain}` : '' }}
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <h2 class="pt-3">Comments</h2>
      <p v-if="comment.question">{{ comment.question }}</p>
      <p v-else>Please leave a few words to help us validate and expedite your request.</p>
      <v-col cols="12" md="6" class="pl-0 pb-0">
        <v-form @submit.prevent="proceed">
          <gg-input-label>Comments <span v-if="commentRequired">(Required)</span></gg-input-label>
          <v-textarea
            v-model="comments"
            outlined
            dense
            rows="3"
            class="gg-input"
            v-validate="{ required: commentRequired }"
            name="Comments"
            :error-messages="errors.collect('Comments')"></v-textarea>
          <v-checkbox
            v-model="agreement"
            color="primary"
            :label="confirmationLabel"
            v-validate="'truthy'"
            name="Agreement"
            :error-messages="errors.collect('Agreement')"></v-checkbox>
        </v-form>
      </v-col>
    </v-card-text>
    <v-card-actions class="pl-3">
      <gg-btn secondary @click="cancelCR" :loading="crCancelLoading">
        Cancel Request
      </gg-btn>
      <gg-btn :loading="loading" :disabled="submitDisabled" @click="proceed">Submit Request</gg-btn>
    </v-card-actions>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validator } from 'vee-validate'
import { decodeHtmlCharCodes } from 'Helpers/helpers'
import crCloseMixin from '@/mixins/crClose'
import { cancellationTypes } from '@/consts/cancellations'

export default {
  name: 'CancelReview',
  mixins: [crCloseMixin],
  props: {
    comment: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      decodeHtmlCharCodes,
      selected: [],
      comments: '',
      loading: false,
      agreement: false,
    }
  },
  computed: {
    ...mapGetters(['selected_cr_service', 'selected_cr_addons', 'cr_id', 'cancellation_type', 'reason_id', 'cr_guided', 'services', 'domains']),
    submitDisabled () {
      const commentValid = this.commentRequired ? !!this.comments.length : true
      return !commentValid || !this.agreement
    },
    commentRequired () {
      if ([true, false].indexOf(this.comment.required) !== -1) {
        return this.comment.required
      }
      return this.comment.required == '1'
    },
    servicesForCancellation () {
      const { type } = this.$route.query
      const serviceId = this.$route.params.service_id
      const data = []
      switch (type) {
        case cancellationTypes.ADDON:
        case cancellationTypes.ID_PROTECT:
          data.push(this.services.find(service => service.id == serviceId))
          break
        case cancellationTypes.DOMAIN:
          const currentDomain = this.domains.find(domain => domain.id == serviceId)
          data.push(currentDomain)
          if (currentDomain.idprotect_serviceid) {
            data.push(this.services.find(service => service.id == currentDomain.idprotect_serviceid))
          }
          break
        case cancellationTypes.HOSTING:
          data.push(this.services.find(service => service.id == serviceId))
          this.services.filter(service => service.related_service == serviceId).forEach(service => data.push(service))
          break
      }
      return data
    },
    cancellationDate () {
      return this.servicesForCancellation.at(0).renewaldate
    },
    confirmationLabel () {
      return `I understand that by proceeding with this action that my account/service will remain active until ${this.cancellationDate}, after which, our system will automatically delete and remove the above account/service(s) from our servers. All data will be lost and will not be recoverable.`
    },
  },
  methods: {
    ...mapActions(['sendCROpen', 'getServices', 'reportError', 'reportSuccess']),
    stepBack () {
      this.$emit('step-back')
    },
    async proceed () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) return

        this.loading = true

        const data = {
          cr_id: this.cr_id,
          comments: this.comments,
        }
        const response = await this.sendCROpen(data)
        // this.$router.push({
        //  name: 'cancellation_details',
        //  params: { id: response.id }
        // })
        this.reportSuccess(response.resultmsg)
        this.getServices()
        this.$emit('cr-opened', {
          tpl: 'cr_open',
          response: response
        })
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    async cancelCR () {
      try {
        await this.crClose(this.cr_id)
      } catch (e) {
        this.reportError(e.resultmsg)
      } finally {
        this.$emit('cancel')
      }
    },
  },
  created () {
    Validator.extend('truthy', {
      getMessage: field => 'The ' + field + ' is required.',
      validate: value => !!value
    })
  }
}
</script>
